import React from 'react';
import { FaTractor, FaUniversity, FaMicrochip, FaChartLine, FaCode, FaDatabase, FaFlask, FaAward } from 'react-icons/fa';
import '../styles/landingPage.scss';

const AboutPage = () => {
  return (
    <div className="lp">
      {/* ── HEADER ─────────────────────────────────────────── */}
      <header className="lp__header lp__header--scrolled">
        <div className="lp__header-inner">
          <a className="lp__logo" href="/">
            <FaTractor /><span>DYNA<em>TECH</em></span>
          </a>
          <nav className="lp__nav">
            <a href="/" className="lp__nav-link">Início</a>
            <a href="/blog" className="lp__nav-link">Blog</a>
          </nav>
        </div>
      </header>

      {/* ── SEÇÃO 01: ORIGEM ────────────────── */}
      <section className="lp__hero" style={{ minHeight: 'auto', paddingTop: '160px', paddingBottom: '80px' }}>
        <div className="lp__hero-overlay" style={{ background: '#0a1a0b' }} />
        <div className="lp__container" style={{ position: 'relative', zIndex: 2 }}>
          <div className="lp__eyebrow" style={{ color: '#A8FF3E' }}>Nossa História</div>
          <h1 style={{ fontSize: '2.8rem', color: '#fff', marginBottom: '2rem', maxWidth: '900px' }}>
            Da sala de aula na <span style={{ color: '#A8FF3E' }}>FEAGRI/Unicamp</span> para a validação no mercado.
          </h1>
          
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '60px', color: '#ccc', lineHeight: '1.8' }}>
            <div>
              <p>
                A <strong>DynaAgTech</strong> não nasceu em uma incubadora de negócios tradicional, mas durante uma aula de 
                mecanização agrícola na Engenharia Agrícola da Unicamp. O problema era claro: a enorme ineficiência energética 
                no campo causada pelo desalinhamento entre trator, implemento e solo.
              </p>
              <p style={{ marginTop: '20px' }}>
                O que começou como um desafio acadêmico evoluiu para o desenvolvimento de soluções que unem 
                <strong> modelagem matemática de tração</strong>, IoT e algoritmos de otimização em tempo real.
              </p>
            </div>
            <div>
              <p>
                Hoje, a startup é classificada como uma <strong>DeepTech</strong>, focada em transformar o rigor científico 
                da engenharia em ferramentas operacionais. Fomos selecionados entre as <strong>60 startups finalistas do Spark 2025 (Sebrae)</strong>, 
                um marco que valida nossa tese de reduzir o consumo de combustível e aumentar a vida útil da frota agrícola.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ── SEÇÃO 02: VALIDAÇÕES TÉCNICAS ──────────────────── */}
      <section style={{ background: '#fff', padding: '100px 0' }}>
        <div className="lp__container">
          <div style={{ textAlign: 'center', marginBottom: '60px' }}>
            <h2 style={{ fontSize: '2rem', color: '#111' }}>Rigor e <span>Validação</span></h2>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '30px' }}>
            <div style={{ border: '1px solid #eee', padding: '40px', borderRadius: '15px' }}>
              <div style={{ color: '#4A8A28', fontSize: '2.5rem', marginBottom: '20px' }}><FaFlask /></div>
              <h4 style={{ marginBottom: '15px' }}>Validação IPT</h4>
              <p style={{ fontSize: '0.95rem', color: '#555' }}>
                Nossas metodologias de teste e coleta de dados passaram pelo crivo técnico do <strong>Instituto de Pesquisas Tecnológicas (IPT)</strong>, 
                garantindo que os ganhos de eficiência prometidos tenham base em medições reais e rastreáveis.
              </p>
            </div>

            <div style={{ border: '1px solid #eee', padding: '40px', borderRadius: '15px' }}>
              <div style={{ color: '#4A8A28', fontSize: '2.5rem', marginBottom: '20px' }}><FaAward /></div>
              <h4 style={{ marginBottom: '15px' }}>Sebrae Spark 2025</h4>
              <p style={{ fontSize: '0.95rem', color: '#555' }}>
                Selecionada no Top 60 do programa Spark 2025, a DynaAgTech foi reconhecida pelo <strong>Sebrae for Startups</strong> como 
                uma das soluções de maior potencial tecnológico no estado de São Paulo.
              </p>
            </div>

            <div style={{ border: '1px solid #eee', padding: '40px', borderRadius: '15px' }}>
              <div style={{ color: '#4A8A28', fontSize: '2.5rem', marginBottom: '20px' }}><FaChartLine /></div>
              <h4 style={{ marginBottom: '15px' }}>Pesquisa Aplicada</h4>
              <p style={{ fontSize: '0.95rem', color: '#555' }}>
                Modelos de predição de condutividade hidráulica apresentados na <strong>Embrapa (SIAGRO)</strong> e reconhecidos com 
                menção honrosa no <strong>CBAGRO</strong>, fundamentando tecnicamente nossas camadas de software.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ── SEÇÃO 03: O DESENVOLVEDOR (ANDRÉ) ──────────────── */}
      <section style={{ background: '#f4f4f4', padding: '100px 0' }}>
        <div className="lp__container">
          <div style={{ background: '#fff', padding: '60px', borderRadius: '20px', display: 'grid', gridTemplateColumns: '1.2fr 1fr', gap: '60px' }}>
            <div>
              <h3 style={{ fontSize: '1.8rem', marginBottom: '25px' }}>Engenharia e <span style={{ color: '#4A8A28' }}>Software</span></h3>
              <p style={{ color: '#555', lineHeight: '1.7', marginBottom: '20px' }}>
                Por trás da arquitetura técnica da DynaAgTech está <strong>André Luiz Bandeli Jr</strong>, graduando em Engenharia Agrícola 
                pela Unicamp e técnico em Mecatrônica pelo Cotuca. Com experiência prática em manutenção industrial (CTDI) 
                e análise de dados climáticos (CEPAGRI/Unicamp), André une o conhecimento do "ferro" (máquinas) ao poder do código.
              </p>
              <p style={{ color: '#555', lineHeight: '1.7' }}>
                Sua stack envolve <strong>Python (Machine Learning)</strong> e <strong>Java (Spring Boot)</strong>, aplicada na criação 
                de pipelines automatizados de dados meteorológicos e modelagem de performance de tração baseada na mecânica 
                clássica de <em>Godwin & Reece</em>.
              </p>
            </div>

            <div style={{ background: '#0a1a0b', padding: '40px', borderRadius: '15px', color: '#fff' }}>
              <h4 style={{ color: '#A8FF3E', marginBottom: '20px' }}>Expertise Técnica</h4>
              <ul style={{ listStyle: 'none', padding: 0, fontSize: '0.9rem' }}>
                <li style={{ marginBottom: '15px', display: 'flex', alignItems: 'center', gap: '15px' }}>
                  <FaUniversity color="#A8FF3E" /> Engenharia Agrícola @ Unicamp
                </li>
                <li style={{ marginBottom: '15px', display: 'flex', alignItems: 'center', gap: '15px' }}>
                  <FaMicrochip color="#A8FF3E" /> Mecatrônica @ Cotuca Unicamp
                </li>
                <li style={{ marginBottom: '15px', display: 'flex', alignItems: 'center', gap: '15px' }}>
                  <FaDatabase color="#A8FF3E" /> Análise Climática & Processamento de Dados
                </li>
                <li style={{ marginBottom: '15px', display: 'flex', alignItems: 'center', gap: '15px' }}>
                  <FaCode color="#A8FF3E" /> ML & Desenvolvimento de APIs
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* ── FOOTER ─────────────────────────────────────────── */}
      <footer className="lp__footer">
        <div className="lp__container">
          <p>© 2025 DynaAgTech · DeepTech de Otimização Agrícola · Campinas, SP.</p>
        </div>
      </footer>
    </div>
  );
};

export default AboutPage;